import { TramRounded } from '@material-ui/icons';
import * as types from '../../constants/actionsType'

const initialState = {
  report: [],
  tableReport: {
    head: [],
    body: []
  },
  submitReport: [],
  isLoadingTable: false,
  isLoadingReport: true,
  isLoadingSubmit: false,
  cardId: "",
  dropdown: [],
  filterLoader: true,
  searchList: [],
  searchLoader: true
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SUCCESS_REPORT:
      var data = [];
      if (action.data.length > 0) {
        var i = 0;
        //dynamically show the report menu - denis
        for(i=0;i<action.data.length;i++)
        {
          data.push({ name: action.data[i].reportName, icon: action.data[i].reportIcon, description: action.data[i].reportDescription, color: '#EE6723', background: 'rgba(87,113,219,0.05)', id: action.data[i].id,order:i+1 });
        }
        // data = [
        //   { name: "Employee Time Data", icon: action.data[0].reportIcon, description: action.data[0].reportDescription, color: '#EE6723', background: 'rgba(87,113,219,0.05)', id: action.data[0].id },
        //   { name: "Application Summary Data", icon: action.data[1].reportIcon, description: action.data[1].reportDescription, color: '#61DB99', background: 'rgba(87,113,219,0.05))', id: action.data[1].id },
        //   { name: "Application Detailed Report", icon: action.data[2].reportIcon, description: action.data[2].reportDescription, color: '#FB8587', background: 'rgba(87,113,219,0.05)', id: action.data[2].id },
        //   { name: "Offline Time Report", icon: action.data[3].reportIcon, description: action.data[3].reportDescription, color: '#FB8587', background: 'rgba(87,113,219,0.05)', id: action.data[3].id },
        //   { name: "Employee Summary Report", icon: action.data[4].reportIcon, description: action.data[4].reportDescription, color: '#FB8587', background: 'rgba(87,113,219,0.05)', id: action.data[4].id },
        //   { name: "Department Summary Report", icon: action.data[5].reportIcon, description: action.data[5].reportDescription, color: '#FB8587', background: 'rgba(87,113,219,0.05)', id: action.data[5].id },
        //   { name: "Employee Holiday Working Hours Report", icon: action.data[6].reportIcon, description: action.data[6].reportDescription, color: '#FB8587', background: 'rgba(87,113,219,0.05)', id: action.data[6].id }
        // ]
      }
      return {
        ...state,
        report: data,
        isLoadingReport: false
      }
    case types.FAILURE_REPORT:
      return {
        ...state,
        report: [],
        isLoadingReport: false

      }
    case types.SUCCESS_TABLE_REPORT:
      var data = action.data.map(i => {
        if(i.reportName=="Application Detailed Report"){
          return [i.reportName, i.fromDate, i.toDate, i.reportDate,i.userName,i.applicaitonName,{exportType:i.exportType}, { filepath: i.fileLocation, status: i.reportStatus }]
          
        }
        else if(i.reportName=="Department Summary Report"){
          return [i.reportName, i.fromDate, i.toDate, i.reportDate,i.businessUnit,i.department,{exportType:i.exportType}, { filepath: i.fileLocation, status: i.reportStatus }]
          
        }
        else{
          return [i.reportName, i.fromDate, i.toDate, i.reportDate,i.userName,i.department,{exportType:i.exportType}, { filepath: i.fileLocation, status: i.reportStatus }]
       
        }
      })
      var head=[];
      if(data[data.length-1][0]=="Application Detailed Report"){
        head=[
          { label: "Report Name", align: "left", },
          { label: "From Date", align: "left" },
          { label: "To Date", align: "left" },
          { label: "Report Date", align: "left" },
          { label: "User", align: "left" },
          { label: "Application", align: "left" },
          { label: "Export Type", align: "left" },
          { label: "Action", align: "right" }
        ]
      
      }
      else if(data[data.length-1][0]=="Department Summary Report"){
        head=[
          { label: "Report Name", align: "left", },
          { label: "From Date", align: "left" },
          { label: "To Date", align: "left" },
          { label: "Report Date", align: "left" },
          { label: "Business Unit", align: "left" },
          { label: "Department", align: "left" },
          { label: "Export Type", align: "left" },
          { label: "Action", align: "right" }
        ]
      }
      else{
        head=[
          { label: "Report Name", align: "left", },
          { label: "From Date", align: "left" },
          { label: "To Date", align: "left" },
          { label: "Report Date", align: "left" },
          { label: "User", align: "left" },
          { label: "Department", align: "left" },
          { label: "Export Type", align: "left" },
          { label: "Action", align: "right" }
        ]
      }
      return {
        ...state,
        tableReport: {
          head: head,
          body: data
        },
      }
    case types.FAILURE_TABLE_REPORT:
      return {
        ...state,
        tableReport: {
          head: [
            { label: "Report Name", align: "left" },
            { label: "From Date", align: "left" },
            { label: "To Date", align: "left" },
            { label: "Report Date", align: "left" },
            { label: "Action", align: "right" }
          ],
          body: []
        },
      }

    case types.SUCCESS_SUBMIT_REPORT:
      return {
        ...state,
        submitReport: action.data,
        isLoadingSubmit: false,
        isLoadingTable: true
      }
    case types.FAILURE_SUBMIT_REPORT:
      return {
        ...state,
        submitReport: action.data,
        isLoadingSubmit: false
      }
    case types.LOADER_SUBMIT_REPORT: {
      return {
        ...state,
        isLoadingSubmit: true
      }
    }
    case types.CARDID_CHANGE:
      return {
        ...state,
        cardId: action.id
      }
    case types.SUCCESS_SEARCH_APPLICATION_DROPDOWN:
      return {
        ...state,
        searchList: action.data,
        searchLoader: false,
      }
    case types.FAILURE_SEARCH_APPLICATION_DROPDOWN:
      return {
        ...state,
        searchList: [],
        searchLoader: true,
      }
    case types.LOADING_REPORT_TABLE:
      return {
        ...state,
        isLoadingTable: action.data
      }
    default:
      return state
  }
}
export default reducer
